import { HttpClient } from '@/core/utils/httpClient'
import { TDriverGrade, TDriverGradeDto, TGradeHistoryEntry } from '../models/DriverGrade.model'

const toSnakeCase = (dto: TDriverGradeDto) => ({
  name: dto.name,
  min_shifts: dto.minShifts,
  min_days_since_signup: dto.minDaysSinceSignup,
  inactive_days: dto.inactiveDays,
  shifts_period_days: dto.shiftsPeriodDays,
})

export class DriverGradesRepository extends HttpClient {
  async fetchGrades(): Promise<TDriverGrade[]> {
    const response = await this.get('/accounting/driver-grades')
    const grades = response.driverGrades ?? response.grades ?? response
    return Array.isArray(grades) ? grades : []
  }

  async createGrade(dto: TDriverGradeDto): Promise<TDriverGrade> {
    const response = await this.post('/accounting/driver-grades', toSnakeCase(dto))
    return response.grade ?? response
  }

  async updateGrade(id: string, dto: TDriverGradeDto): Promise<TDriverGrade> {
    const response = await this.put(`/accounting/driver-grades/${id}`, toSnakeCase(dto))
    return response.grade ?? response
  }

  async deleteGrade(id: string): Promise<void> {
    await this.delete(`/accounting/driver-grades/${id}`)
  }

  async overrideGrade(driverId: string, gradeId: string): Promise<void> {
    await this.post('/accounting/driver-grades/override', {
      driver_id: Number(driverId),
      grade_id: gradeId,
    })
  }

  async fetchGradeHistory(driverId: string): Promise<TGradeHistoryEntry[]> {
    const response = await this.get(`/accounting/driver-grades/history/${driverId}`)
    const changes = response.changes ?? response
    return Array.isArray(changes) ? changes : []
  }

  async updateScheduleTask(scheduleId: string, date: string): Promise<void> {
    await this.post('/worker/updateScheduleTask', { scheduleId, date })
  }
}
